import $ from 'jquery';

const SELECTORS = {
    ITEM_QTY_INPUT: '.js-cartController-qty'
}

export default class CartModel {
    constructor() {
        this.cartArray = [];
        this.removedItemArray = [];
        this.changeTrackingArray = [];

        this.setupHandlers();
    }

    setupHandlers() {
        this.createCartArray = this._createCartArray.bind(this);
        this.locateAndRemoveUndoItem = this._locateAndRemoveUndoItem.bind(this);
        this.addToRemovedItemArray = this._addToRemovedItemArray.bind(this);
        this.updateTrackingArray = this._updateTrackingArray.bind(this);
    }

    _createCartArray($productRows) {
        $productRows.each((i, val) => {
            let item = {};
            item.id = $(val).find(SELECTORS.ITEM_QTY_INPUT)[0].dataset.productId;
            item.qty = parseInt($(val).find(SELECTORS.ITEM_QTY_INPUT)[0].value);
            item.entryGroupNumber = $(val).find(SELECTORS.ITEM_QTY_INPUT)[0].dataset.entryGroupNumber;
            item.inStock = parseInt($(val).find(SELECTORS.ITEM_QTY_INPUT)[0].dataset.qtyInStock);
            item.isOutOfStock = ($(val).find(SELECTORS.ITEM_QTY_INPUT)[0].dataset.isOutOfStock.toLowerCase() === 'true');
            this.cartArray.push(item);
        });

        /* Clone of array for tracking differences */
        this.changeTrackingArray = JSON.parse(JSON.stringify(this.cartArray));
    }

    _addToRemovedItemArray(prevObject) {
        this.removedItemArray.push(prevObject);
    }

    _locateAndRemoveUndoItem(updateObject) {
        const indexToRemove = this.removedItemArray.findIndex((obj) => {
            return obj.id === updateObject.productId;
        });

        if (indexToRemove > -1) {
            this.removedItemArray.splice(indexToRemove, 1);
        }

        for (let i = 0; i < this.changeTrackingArray.length; i++) {
            if (this.changeTrackingArray[i].id == updateObject.productId) {
                this.changeTrackingArray[i].qty = updateObject.qty;
                this.changeTrackingArray[i].entryGroupNumber = updateObject.entryGroupNumber;
            }
        }
    }

    updateCartArray(params) {
        const id = params.productId.toString();
        for (let i = 0; i < this.cartArray.length; i++) {
            if (this.cartArray[i].id === id) {
                this.cartArray[i].qty = parseInt(params.qty);
                this.cartArray[i].entryGroupNumber = parseInt(params.entryGroupNumber);
            }
        }
        return this;
    }

    _updateTrackingArray(id, qty) {
        id = id.toString();
        qty = parseInt(qty);

        for (let j = 0; j < this.changeTrackingArray.length; j++) {
            if (this.changeTrackingArray[j].id === id) {
                this.changeTrackingArray[j].qty = qty;
            }
        }

        return this;
    }
}